<div class="l-d-f l-ai-cen language-switch">
  <cds-icon icon="general:globe" (click)="toggle()"></cds-icon>
  <cds-icon [icon]="isShowLanguageList ? 'action:button_up' : 'action:down'" (click)="toggle()"></cds-icon>

  @if (isShowLanguageList) {
  <div class="button-list">
    @for (language of languages; track language) {
    <span class="cds-detail2-demibold language-text" (click)="changeLang(language.value)">{{ language.label }}</span>
    }
    <div class="mask" (click)="isShowLanguageList = false"></div>
  </div>
  }
</div>
